import appDataSliceReducer from "./features/appData/appDataSlice";
// import annotationSlice from "./features/annotation/annotationSlice";
import linkPreviewSlice from "./features/linkPreview/linkPreviewSlice";
import connectedAppsSlice from "./features/connectedApps/connectedAppsSlice";
import accountSlice from "./features/account/accountSlice";
import { configureStore } from "@reduxjs/toolkit";
import { loadState } from "../utils/localStorage";
import agentSlice from "./features/agent/agentSlice";

const loadedState = loadState();
const preloadedState = loadedState
  ? {
      ...loadedState,
      appData: {
        ...loadedState.appData,
        adminAuth: loadedState.appData?.adminAuth || {
          isAuthenticated: false,
          adminSecret: "",
          verifiedAt: null,
        },
      },
      agent: {
        ...loadedState.agent,
        // Ensure canvasMode is always present with proper structure
        canvasMode: {
          isOpen: false,
          document: null,
          ui: {
            sidebar: {
              width: 400,
              isCollapsed: false,
            },
            showUnsavedChangesModal: false,
            isExporting: false,
            isSavingToResources: false,
            isSavingToDocuments: false,
            isGeneratingTitle: false,
          },
          // Preserve any existing canvasMode state if it exists
          ...(loadedState.agent?.canvasMode || {}),
        },
        // Ensure employeeProfileSidebar is always present with proper structure
        employeeProfileSidebar: {
          isOpen: false,
          employeeId: null,
          employeeData: null,
          isLoading: false,
          type: null,
        },
        // Ensure documentPreviewModal is always present with proper structure
        documentPreviewModal: {
          isOpen: false,
          document: null,
        },
      },
    }
  : undefined;

const store = configureStore({
  preloadedState: preloadedState,
  reducer: {
    appData: appDataSliceReducer,
    account: accountSlice,
    linkPreview: linkPreviewSlice,
    connectedApps: connectedAppsSlice,
    agent: agentSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Allow Date objects in specific paths where messages are stored
        ignoredPaths: ["agent.messages", "agent.canvasMode.message"],
        // Allow Date constructor in actions that handle messages
        ignoredActionsPaths: [
          "payload.createdAt",
          "payload.updatedAt",
          "payload.messages",
          "payload.message",
        ],
      },
    }),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
